import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/stores/auth';
import { UserRole } from '../../shared';

interface AdminRouteProps {
  children: React.ReactNode;
}

const adminRoles: UserRole[] = [UserRole.SUPER_ADMIN, UserRole.ADMIN];
/** Páginas do admin abertas também a instrutores: a caixa de dúvidas. */
const instructorPaths = ['/admin/duvidas'];
export const INSTRUCTOR_HOME = '/admin/duvidas';

/** Mesma regra para a rota e para o menu: admin abre tudo; instrutor, só a caixa. */
export function canOpenAdminPath(role: string | undefined, pathname: string) {
  if (adminRoles.includes(role as UserRole)) return true;
  return (
    role === UserRole.INSTRUCTOR &&
    instructorPaths.some((path) => pathname === path || pathname.startsWith(`${path}/`))
  );
}

export function AdminRoute({ children }: AdminRouteProps) {
  const { isAuthenticated, user } = useAuthStore();
  const { pathname } = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!user || !canOpenAdminPath(user.role, pathname)) {
    const home = user?.role === UserRole.INSTRUCTOR ? INSTRUCTOR_HOME : '/dashboard';
    return <Navigate to={home} replace />;
  }

  return <>{children}</>;
}
